<template>
  <transition name="fade">
    <div
      v-if="visible && selectedFile"
      :class="inline ? 'relative h-full' : 'fixed inset-0 z-[1000]'"
      class="flex flex-col bg-slate-950 overflow-hidden"
    >
      <!-- TOAST -->
      <div id="viewer-toast-container" class="toast-container"></div>

      <!-- HEADER -->
      <header class="flex items-center justify-between px-4 md:px-6 h-16 bg-slate-900/90 backdrop-blur-xl border-b border-white/5 shadow-2xl shrink-0">
<div class="flex items-center gap-3 overflow-hidden min-w-0 flex-1">
  <div
    class="flex items-center justify-center w-9 h-9 rounded-xl shrink-0 shadow-lg"
    :class="getTypeBg(selectedFile?.type)"
  >
    <i :class="getFileIcon(selectedFile?.type)" class="text-white text-base"></i>
  </div>

<div class="min-w-0">
  <h3 class="text-sm font-semibold text-white truncate leading-[1.1] m-0">
    {{ selectedFile?.name }}
  </h3>

  <p
    class="text-[10px] uppercase tracking-wider font-medium text-blue-400 truncate leading-[1.1] m-0"
  >
    {{ selectedFile?.uploader?.name || `ID: ${selectedFile?.id?.substring(0, 8)}` }}
  </p>
</div>
</div>
        <!-- Acciones header -->
        <div class="flex items-center gap-1 shrink-0 ml-2">
          <button @click="showQR = true" class="icon-btn" title="Ver QR">
            <i class="ri-qr-code-line text-xl"></i>
          </button>
          <button @click="copyLink" class="icon-btn" title="Copiar enlace">
            <i class="ri-links-line text-xl"></i>
          </button>
          <div class="w-px h-5 bg-white/10 mx-1"></div>
          <button @click="close" class="icon-btn hover:bg-red-500/20 hover:text-red-400" title="Cerrar">
            <i class="ri-close-line text-xl"></i>
          </button>
        </div>
      </header>

      <!-- MAIN -->
      <main class="flex-1 relative flex flex-col overflow-hidden" style="min-height:0;">

        <!-- LOADING -->
        <div v-if="loading" class="flex-1 flex flex-col items-center justify-center gap-5">
          <div class="spinner"></div>
          <p class="text-slate-500 text-[11px] font-bold uppercase tracking-[0.2em]">Cargando recurso…</p>
        </div>

        <template v-else>

          <!-- IMAGEN -->
          <!-- IMAGEN -->
<div
  v-if="isImage"
  class="flex-1 flex items-center justify-center p-6 md:p-12 bg-[radial-gradient(ellipse_at_center,_#1e293b_0%,_#020617_100%)] relative overflow-hidden"
  @mousemove="onImageMouseMove"
  @mouseenter="showMagnifier = true"
  @mouseleave="showMagnifier = false"
  ref="imageContainer"
>
  <img
    :src="selectedFile?.url"
    ref="mainImage"
    class="max-w-full max-h-full object-contain animate-zoom rounded-lg shadow-2xl ring-1 ring-white/5"
    @click="zoomed = !zoomed"
    :class="zoomed ? 'cursor-zoom-out scale-150 transition-transform duration-300' : 'cursor-none'"
    draggable="false"
  />

  <!-- LUPA -->
  <div
    v-if="showMagnifier && !zoomed"
    class="pointer-events-none fixed z-50 w-44 h-44 rounded-full border-2 border-white/30 shadow-2xl overflow-hidden ring-4 ring-black/20"
    :style="{
      left: magnifier.x + 'px',
      top: magnifier.y + 'px',
      transform: 'translate(-50%, -50%)',
      backgroundImage: `url(${selectedFile?.url})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: `${magnifier.imgW * magnifierZoom}px ${magnifier.imgH * magnifierZoom}px`,
      backgroundPosition: `-${magnifier.bgX}px -${magnifier.bgY}px`,
    }"
  >
    <!-- Cruz central -->
    <div class="absolute inset-0 flex items-center justify-center pointer-events-none">
      <div class="w-px h-full bg-white/20 absolute"></div>
      <div class="h-px w-full bg-white/20 absolute"></div>
      <div class="w-2 h-2 rounded-full border border-white/50 bg-transparent"></div>
    </div>
    <!-- Borde brillante -->
    <div class="absolute inset-0 rounded-full ring-1 ring-inset ring-white/10"></div>
  </div>

  <!-- Hint -->
  <div class="absolute bottom-4 right-4 flex items-center gap-2 bg-black/40 backdrop-blur-sm text-white/50 text-[11px] px-3 py-1.5 rounded-full select-none">
    <i class="ri-zoom-in-line text-sm"></i>
    Mueve el cursor para ampliar
  </div>
</div>

          <!-- VIDEO -->
          <div v-else-if="isVideo" class="w-full h-full flex items-center justify-center bg-black overflow-hidden p-4 md:p-10">
            <div class="w-full max-w-4xl aspect-video">
              <video ref="videoElement" :src="selectedFile?.url" playsinline crossorigin="anonymous" class="w-full h-full object-contain shadow-2xl" controls />
            </div>
          </div>

          <!-- AUDIO -->
          <div v-else-if="isAudio" class="flex-1 flex items-center justify-center p-4 md:p-10 bg-[radial-gradient(ellipse_at_center,_#1e293b_0%,_#020617_100%)]">
            <div class="w-full max-w-2xl space-y-4">

              <!-- Card audio -->
              <div class="bg-slate-900 border border-white/5 rounded-3xl shadow-2xl overflow-hidden">
               
                <!-- Player -->
                <div class="px-5 py-5">
                  <audio
                    ref="videoElement"
                    :src="selectedFile?.url"
                    playsinline
                    crossorigin="anonymous"
                    controls
                    class="w-full"
                  />
                </div>
              </div>

              <!-- Botón transcribir -->
              <button
                v-if="!transcription"
                @click="transcribeAudio"
                :disabled="transcribing"
                class="flex w-full items-center justify-center gap-2.5 px-5 py-3 rounded-2xl text-sm font-semibold
                       bg-blue-600 text-white hover:bg-blue-500 active:scale-[0.98]
                       disabled:opacity-50 disabled:cursor-not-allowed transition-all shadow-lg shadow-blue-900/30"
              >
                <i v-if="transcribing" class="ri-loader-4-line animate-spin text-base"></i>
                <i v-else class="ri-file-text-line text-base"></i>
                {{ transcribing ? 'Transcribiendo audio…' : 'Transcribir audio con IA' }}
              </button>

              <!-- Transcripción -->
              <transition name="fade">
                <div v-if="transcription" class="bg-slate-900 border border-white/5 rounded-2xl overflow-hidden shadow-xl">
                  <div class="flex items-center gap-2 px-4 py-3 border-b border-white/5 bg-white/[0.02]">
                    <i class="ri-file-text-line text-blue-400 text-sm"></i>
                    <p class="text-[10px] uppercase tracking-widest text-slate-400 font-bold">Transcripción</p>
                  </div>
                  <div class="px-4 py-4 max-h-56 overflow-y-auto">
                    <p class="text-slate-300 text-sm leading-relaxed whitespace-pre-wrap">{{ transcription }}</p>
                  </div>
                </div>
              </transition>
            </div>
          </div>

          <!-- PDF -->
          <div v-else-if="isPdf" class="flex-1 w-full overflow-hidden bg-slate-900" style="min-height:0;">
            <vue-pdf-app
              :pdf="pdfUrl"
              class="w-full h-full border-0"
              style="height:100%; display:block;"
              title="Vista previa del PDF"
            />
          </div>

          <!-- VISOR DE OFFICE (Word, Excel, PowerPoint) -->
          <div v-else-if="isOfficeDoc" class="flex-1 w-full bg-white relative" style="min-height:0;">
            <iframe
              :src="officeUrl"
              class="absolute inset-0 w-full !h-full border-0 block"
              frameborder="0"
              title="Vista previa del documento"
            ></iframe>
          </div>

          <!-- VISOR DE PROXY / GENÉRICO (Para enlaces sin extensión) -->
          <div v-else-if="isProxied" class="flex-1 w-full bg-white relative" style="min-height:0;">
            <iframe
              :src="selectedFile.url"
              class="absolute inset-0 w-full !h-full border-0 block"
              frameborder="0"
              title="Vista previa del archivo"
            ></iframe>
          </div>

        </template>
      </main>

      <!-- QR MODAL -->
      <transition name="fade">
        <div v-if="showQR" class="fixed inset-0 z-[1100] flex items-center justify-center p-4">
          <div class="absolute inset-0 bg-black/70 backdrop-blur-sm" @click="showQR = false"></div>
          <div class="relative bg-white rounded-3xl p-6 shadow-2xl w-full max-w-[320px] z-50 flex flex-col items-center gap-4">
            <div class="w-full flex items-center justify-between">
              <h3 class="text-sm font-bold text-slate-800">Abrir en dispositivo</h3>
              <button @click="showQR = false" class="text-slate-400 hover:text-slate-600 transition-colors">
                <i class="ri-close-line text-lg"></i>
              </button>
            </div>
            <div class="p-2 bg-slate-50 rounded-2xl border border-slate-100">
              <img :src="getQrUrl(selectedFile?.url)" alt="QR" class="w-64 h-64 object-contain" />
            </div>
            <button
              @click="copyLink"
              class="w-full py-2.5 rounded-2xl bg-slate-900 hover:bg-slate-800 text-white text-xs font-bold tracking-wide transition-colors flex items-center justify-center gap-2"
            >
              <i class="ri-links-line"></i>
              Copiar enlace
            </button>
          </div>
        </div>
      </transition>

      <!-- FOOTER -->
      <footer class="h-18 shrink-0 w-full bg-slate-900/90 backdrop-blur-xl border-t border-white/5 flex items-center justify-between px-4 md:px-8 py-3">

        <!-- Proyección -->
        <div class="flex items-center" v-if="!hideProjection">
          <button
            @click="toggleProjection"
            :class="isProjecting
              ? 'bg-red-600 hover:bg-red-500 text-white shadow-lg shadow-red-900/40'
              : 'bg-white/10 hover:bg-white/15 text-white border border-white/10'"
            class="flex items-center gap-2 px-5 py-2.5 rounded-2xl font-bold text-xs tracking-wide transition-all active:scale-95"
          >
            <i :class="isProjecting ? 'ri-stop-circle-line' : 'ri-cast-line'" class="text-base"></i>
            {{ isProjecting ? 'Detener proyección' : 'Proyectar pantalla' }}
          </button>
        </div>
        <div v-else class="flex-1"></div>

        <!-- Acciones footer -->
        <div class="flex items-center gap-2">
          <button v-if="!hideDelete"
            @click="$emit('delete', selectedFile)"
            class="flex items-center gap-1.5 px-3 py-2 rounded-xl text-slate-500 hover:text-red-400 hover:bg-red-500/10 transition-all text-xs font-medium"
            title="Eliminar"
          >
            <i class="ri-delete-bin-6-line text-base"></i>
            <span class="hidden md:inline">Eliminar</span>
          </button>
          <div class="w-px h-6 bg-white/10"></div>
          <button
            @click="close"
            class="flex items-center gap-1.5 px-5 py-2.5 rounded-xl bg-white/8 hover:bg-white/12 text-white text-xs font-bold tracking-wide transition-all border border-white/5"
          >
            Cerrar
          </button>
        </div>
      </footer>
    </div>
  </transition>
</template>
<script>
import { db } from '@/fb';
import { doc, getDoc, updateDoc, serverTimestamp } from 'firebase/firestore';
import Plyr from 'plyr';
import 'plyr/dist/plyr.css';
import axios from 'axios';
import VuePdfApp from "vue-pdf-app";
// import this to use default icons for buttons
import "vue-pdf-app/dist/icons/main.css";
const BACKEND_URL = 'https://api.jgmun.com/api';

export default {
  name: 'FileViewer',
    components: {
    VuePdfApp
  },
  props: {
    fileId: { type: String, default: null },
    visible: { type: Boolean, default: false },
    inline: { type: Boolean, default: false },
    hideDelete: { type: Boolean, default: false },

    hideProjection: { type: Boolean, default: false }
  },
  data() {
    return {
      loading: false,
      selectedFile: null,
      transcription: '',
      transcribing: false,
      isProjecting: false,
      showQR: false,
      socket: null,
      playerInstance: null,
      zoomed: false,
showMagnifier: false,
magnifier: { x: 0, y: 0, bgX: 0, bgY: 0, imgW: 0, imgH: 0 },
magnifierZoom: 3,
    };
  },
  computed: {
    authContext() { return this.$delegateStore.state.authContext || {}; },
    isImage() { return this.selectedFile?.type === 'img'; },
    isVideo() { return this.selectedFile?.type === 'video'; },
    isAudio() { return this.selectedFile?.type === 'audio'; },
    isPdf()   { return this.selectedFile?.url?.toLowerCase().includes('.pdf'); },
    pdfUrl()  { return this.selectedFile?.url ? `${this.selectedFile.url}#view=FitH` : ''; },
    isOfficeDoc() {
      const url = this.selectedFile?.url?.toLowerCase() || '';
      return url.includes('.doc') || url.includes('.xls') || url.includes('.ppt');
    },
    officeUrl() {
      return `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(this.selectedFile?.url)}`;
    },
    isProxied() {
      const url = this.selectedFile?.url || '';
      return url.includes('/proxy?url=');
    }
  },
  watch: {
    fileId: { immediate: true, handler: 'loadFile' },
    visible: {
      immediate: true,
      handler(val) {
        if (!val) this.cleanup();
        else this.initSocket();
      }
    }
  },
  methods: {
    onImageMouseMove(e) {
  const img = this.$refs.mainImage;
  if (!img) return;

  const rect = img.getBoundingClientRect();

  // Posición del cursor en pantalla (para ubicar la lupa)
  this.magnifier.x = e.clientX;
  this.magnifier.y = e.clientY;

  // Tamaño renderizado de la imagen
  this.magnifier.imgW = rect.width;
  this.magnifier.imgH = rect.height;

  // Posición relativa del cursor dentro de la imagen
  const relX = e.clientX - rect.left;
  const relY = e.clientY - rect.top;

  // Offset del background para centrar el zoom en el cursor
  const lensSize = 176; // w-44 = 11rem = 176px
  this.magnifier.bgX = relX * this.magnifierZoom - lensSize / 2;
  this.magnifier.bgY = relY * this.magnifierZoom - lensSize / 2;
},
    async loadFile() {
      if (!this.fileId || !this.visible) return;
      this.loading = true;
      try {
        const docRef = doc(db, `commissions/${this.authContext.cohort}/commissions/${this.authContext.commissionId}/media/${this.fileId}`);
        const snap = await getDoc(docRef);
        if (snap.exists()) {
          const data = snap.data();
          let url = data.url || data.fileUrl;
          if (!url && data.fileKey)  url = `${BACKEND_URL}/docs/${data.fileKey}`;
          
          // Si el enlace no tiene extensión, se utiliza el proxy especificado
          const fileName = url ? url.split(/[?#]/)[0].split('/').pop() : '';
          if (url && !fileName.includes('.') && !url.includes('/proxy?url=')) {
            url = `${BACKEND_URL}/proxy?url=${encodeURIComponent(url)}`;
          }

          this.selectedFile = { id: snap.id, ...data, url };
          this.transcription = data.transcription?.text || '';
        }
      } catch (e) {
      } finally {
        this.loading = false;
        if (this.selectedFile && (this.isAudio || this.isVideo)) {
          await this.$nextTick();
          this.setupPlayer();
        }
      }
    },
    async getSignedUrl(fileKey) {
      const encodedKey = fileKey.split('/').map(encodeURIComponent).join('/');
      const res = await fetch(`${BACKEND_URL}/docs/${encodedKey}`);
      const data = await res.json();
      return res;
    },
    setupPlayer() {
      if (!this.$refs.videoElement) return;
      if (this.playerInstance) this.playerInstance.destroy();
      this.playerInstance = new Plyr(this.$refs.videoElement, {
        controls: ['play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
      });
      this.playerInstance.on('play', () => this.isProjecting && this.sendCommand('play'));
      this.playerInstance.on('pause', () => this.isProjecting && this.sendCommand('pause'));
    },
    initSocket() {
      if (this.socket) return;
      this.socket = new WebSocket('wss://api.jgmun.com/ws');
      this.socket.onclose = () => {
        if (this.visible) setTimeout(() => this.initSocket(), 5000);
      };
    },
    sendCommand(action, extra = {}) {
      if (this.socket?.readyState === WebSocket.OPEN) {
        this.socket.send(JSON.stringify({
          type: 'media-control',
          roomId: this.authContext.commissionId,
          transcription: this.transcription,
          action,
          ...extra
        }));
      }
    },
    toggleProjection() {
      this.isProjecting = !this.isProjecting;
      this.sendCommand(this.isProjecting ? 'open' : 'close', {
        file: this.selectedFile,
      });
    },
    async transcribeAudio() {
      this.transcribing = true;
      try {
        const key = this.selectedFile.fileKey;
        const start = await fetch(`${BACKEND_URL}/transcribe/start`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ key }),
        });
        const { jobName } = await start.json();
        
        let completed = false;
        while (!completed) {
          await new Promise(r => setTimeout(r, 3000));
          const res = await fetch(`${BACKEND_URL}/transcribe/status/${jobName}`);
          const data = await res.json();
          if (data.status === 'COMPLETED') {
            this.transcription = data.text;
            const docRef = doc(db, `commissions/${this.authContext.cohort}/commissions/${this.authContext.commissionId}/media/${this.selectedFile.id}`);
            await updateDoc(docRef, { transcription: { text: data.text, createdAt: serverTimestamp() } });
            completed = true;
          }
        }
      } finally {
        this.transcribing = false;
      }
    },
    cleanup() {
      if (this.isProjecting) this.toggleProjection();
      if (this.playerInstance) this.playerInstance.destroy();
      this.playerInstance = null;
      this.selectedFile = null;
      this.socket?.close();
      this.socket = null;
      this.zoomed = false;
this.showMagnifier = false;
    },
    close() {
      this.$emit('close');
    },
    copyLink() {
      navigator.clipboard.writeText(this.selectedFile.url);
    },
    getQrUrl(url) {
      return `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodeURIComponent(url)}`;
    },
    getFileIcon(type) {
      if (this.isOfficeDoc) return 'ri-file-word-2-fill';
      const icons = { img: 'ri-image-2-fill', video: 'ri-movie-fill', pdf: 'ri-file-pdf-2-fill', audio: 'ri-music-2-fill' };
      return icons[type] || (this.isPdf ? 'ri-file-pdf-2-fill' : 'ri-file-3-line');
    },
    getTypeBg(type) {
      if (this.isOfficeDoc) return 'bg-blue-700';
      const bgs = { img: 'bg-emerald-600', video: 'bg-red-600', pdf: 'bg-orange-600', audio: 'bg-purple-600' };
      return bgs[type] || (this.isPdf ? 'bg-orange-600' : 'bg-blue-600');
    }
  }
};
</script>

<style scoped>
.spinner {
  width: 40px; height: 40px;
  border: 3px solid rgba(255,255,255,0.1);
  border-top-color: #3b82f6;
  border-radius: 50%;
  animation: spin .8s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }

.icon-btn {
  width: 40px; height: 40px;
  display: flex; align-items: center; justify-content: center;
  border: none; background: transparent; color: white; cursor: pointer;
  border-radius: 50%; transition: background .2s;
}
.icon-btn:hover { background: rgba(255,255,255,.1); }

.fade-enter-active, .fade-leave-active { transition: opacity .3s ease; }
.fade-enter-from, .fade-leave-to { opacity: 0; }

@keyframes zoom {
  from { opacity: 0; transform: scale(.95); }
  to   { opacity: 1; transform: scale(1); }
}
.animate-zoom { animation: zoom .4s cubic-bezier(.16, 1, .3, 1); }
</style>